import { useState } from "react";
import { joinBreathworkWaitlist } from "@/lib/api";

export const BreathworkWaitlistForm = () => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ first_name: "", last_name: "", email: "", phone: "", message: "" });
  const [status, setStatus] = useState("idle");
  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    try {
      await joinBreathworkWaitlist(form);
      setStatus("done");
    } catch {
      setStatus("error");
    }
  };

  if (status === "done") {
    return (
      <p data-testid="breathwork-waitlist-success" className="mt-10 serif italic text-[18px] text-[#2E2B27]">
        Thank you, {form.first_name}. You're on the list — I'll write to you personally when breathwork opens in September.
      </p>
    );
  }

  if (!open) {
    return (
      <button type="button" onClick={() => setOpen(true)} data-testid="breathwork-waitlist-btn" className="btn-ghost mt-10 inline-flex">
        Join the Waiting List
      </button>
    );
  }

  return (
    <form onSubmit={submit} data-testid="breathwork-waitlist-form" className="mt-10 space-y-5 border-t border-[#D5CDBF] pt-8 max-w-xl">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div><label className="label-eyebrow" htmlFor="bw-fn">First name</label>
          <input id="bw-fn" required data-testid="breathwork-first-name" className="input-soft" value={form.first_name} onChange={update("first_name")} /></div>
        <div><label className="label-eyebrow" htmlFor="bw-ln">Surname</label>
          <input id="bw-ln" required data-testid="breathwork-last-name" className="input-soft" value={form.last_name} onChange={update("last_name")} /></div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div><label className="label-eyebrow" htmlFor="bw-em">Email</label>
          <input id="bw-em" type="email" required data-testid="breathwork-email" className="input-soft" value={form.email} onChange={update("email")} /></div>
        <div><label className="label-eyebrow" htmlFor="bw-ph">Phone</label>
          <input id="bw-ph" required minLength={6} data-testid="breathwork-phone" className="input-soft" value={form.phone} onChange={update("phone")} /></div>
      </div>
      <div>
        <label className="label-eyebrow" htmlFor="bw-msg">What would you hope to receive from a private breathwork session? (optional)</label>
        <textarea id="bw-msg" rows={3} data-testid="breathwork-message" className="input-soft resize-none" value={form.message} onChange={update("message")} />
      </div>
      {status === "error" && <p className="text-[13px]" style={{ color: "var(--terracotta)" }}>Please check the details and try again.</p>}
      <div className="flex items-center gap-4">
        <button type="submit" data-testid="breathwork-waitlist-submit" disabled={status === "loading"} className="btn-primary">
          {status === "loading" ? "Sending…" : "Join the Waiting List"}
        </button>
        <button type="button" onClick={() => setOpen(false)} className="text-[12px] uppercase tracking-[0.22em] text-[#55524C]">Back</button>
      </div>
    </form>
  );
};
